import React from "react";

function ApprovedVendorIcon() {
  return (
    <svg
      width="87"
      height="87"
      viewBox="0 0 87 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="43.2347"
        cy="43.2347"
        r="43.2347"
        fill="#39B260"
        fill-opacity="0.19"
      />
      <circle
        cx="43.2335"
        cy="43.2353"
        r="30.8819"
        fill="#39B260"
        fill-opacity="0.17"
      />
      <path
        d="M41.4133 48.2856L35.8544 43.4245L37.7069 41.8049L41.4133 45.0441L48.8235 38.5645L50.6774 40.1853L41.4133 48.2856Z"
        fill="#2ECC71"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.3017 43.3442C29.3017 36.3859 35.7542 30.7448 43.7133 30.7448C51.6724 30.7448 58.1248 36.3859 58.1248 43.3442C58.1248 50.3026 51.6724 55.9437 43.7133 55.9437C35.7542 55.9437 29.3017 50.3026 29.3017 43.3442ZM43.7133 53.6529C42.1648 53.6529 40.6315 53.3863 39.2009 52.8682C37.7704 52.3501 36.4705 51.5908 35.3756 50.6336C34.2806 49.6763 33.4121 48.5399 32.8195 47.2892C32.227 46.0385 31.922 44.698 31.922 43.3442C31.922 41.9905 32.227 40.65 32.8195 39.3993C33.4121 38.1486 34.2806 37.0122 35.3756 36.0549C36.4705 35.0977 37.7704 34.3383 39.2009 33.8203C40.6315 33.3022 42.1648 33.0356 43.7133 33.0356C46.8405 33.0356 49.8397 34.1217 52.051 36.0549C54.2623 37.9882 55.5046 40.6102 55.5046 43.3442C55.5046 46.0783 54.2623 48.7003 52.051 50.6336C49.8397 52.5668 46.8405 53.6529 43.7133 53.6529Z"
        fill="#2ECC71"
      />
    </svg>
  );
}

export default ApprovedVendorIcon;
